import React, { useRef, useImperativeHandle, useMemo } from "react";
import SmartFitnessBandFeeTable from "@icoach/accountBook/tables/SmartFitnessBandFeeTable";
import { Grid, Box, Card, List, ListItemText, CheckboxField } from "@curves/ui-base";
import clsx from "clsx";
import { refIsRequiredError } from "@util/utils";

// 智能月費Table
export const SmartFitnessBandFeeContent = React.forwardRef((props, ref) => {
	const { className, sourceData } = props;

	// 計算總計（單筆或多筆）
	const calculateTotal = () => {
		if (!sourceData) return 0;
		if (Array.isArray(sourceData)) {
			return sourceData.reduce((sum, item) => sum + (item.assignPrice || 0), 0);
		}
		return sourceData.assignPrice || 0;
	};

    const value = useMemo(() => {
        return calculateTotal();
    }, 
    // eslint-disable-next-line
    [sourceData]);

	return (
		<Box className={clsx("cart-content", "overflow-scroll", className)}>
			<SmartFitnessBandFeeTable className={"theme-gray mb-3"} sourceData={sourceData} />
			<Grid spacing={3} container>
				<Grid className={"ml-auto"} xs={4} item>
					<List>
						<ListItemText className={"cart-info total"} secondary={"總計"} primary={value} />
					</List>
				</Grid>
			</Grid>
		</Box>
	);
});

export const CheckoutSmartFitnessBandFee = React.forwardRef((props, ref) => {
	const { className, sourceData } = props;
	const confirmRef = useRef(null);
	const smartFitnessBandFeeContentRef = useRef(null);

	useImperativeHandle(
		ref,
		() => ({
			getResult: () => {
				let result = {};

				if (sourceData) {
					// 如果是陣列，返回陣列；如果是單一物件，也返回陣列格式
					result.deviceOrderItems = sourceData;
				}

				return result;
			},
			isError: () => {
				// 檢查 checkbox 是否有勾選
				return refIsRequiredError(confirmRef);
			},
		}),
		[sourceData]
	);

	return (
		<Card className={clsx(className)}>
			<Card.CardContent>
				<SmartFitnessBandFeeContent ref={smartFitnessBandFeeContentRef} sourceData={sourceData} />
				<Box className={"cart-actions"}>
					<CheckboxField ref={confirmRef} required helperText="此選項為必填欄位">
						<CheckboxField.Checkbox label="已通知會員，因有訂閱智能系統，在收取會籍月費同時，需額外收取對應的智能月費；智能月費的扣款則由系統後台自動批次處理。" value={true} />
					</CheckboxField>
				</Box>
			</Card.CardContent>
		</Card>
	);
});

export default CheckoutSmartFitnessBandFee;
